<template>
  <div class="opera-ft">
    <topNav ref="topnav" :title="!isMultSelect? $t('fangT_title'):mutlSelectTitle" :selectMore="true"
            @goSelect="goSelect" @operateMultSelected="operateMultSelected"
            @cancleSelectMore="cancleSelectMore"></topNav>
    <div class="fangt_top">
      <div class="search">
        <i class="iconfont icon-sousuo"></i>
        <input type="text" id='searchInput' x-webkit-speech v-model='searchOption.searchText' name=""
               :placeholder="$t('fangT_placeholder')">
        <div class="cleartext" @click="searchOption.searchText='';getData();" v-if="searchOption.searchText != ''">
          <i class="iconfont icon-cuowu"></i>
        </div>
        <div class="cleartext" v-else>
          <i class="iconfont icon-yuyin" @click="startRecognize"></i>
        </div>
      </div>
      <div class="searct_btn" @click='getData'>{{$t('search')}}</div>
      <span class="line"></span>
      <mt-button @click.native="showFliter">
        <div class="fliter">{{$t('fliter')}}
          <i class="iconfont icon-xia"></i>
        </div>
      </mt-button>
    </div>
    <mt-loadmore :top-method="loadTop" @top-status-change="handleTopChange" :top-status.sync="topStatus" ref="loadmore">
      <div class="all_ft">
        <div class="roomList" v-for='(item,key) in roomList.statusresult' @click='touchitem(item)' :key="item.rmno">
          <div class="item" :style='{background:item.c}' :class="{'rightBorder':(key+1)%5!=0}">
            <p class="roomNo">
              {{item.rmno}}
            </p>
            <i class="iconfont icon-peopleb2ren" v-if="item.arr == 'T'&& item.sta!='OD' && item.sta!='OC'"></i>
            <i class="iconfont icon-renyuandingwei" v-if="item.sta=='OD'||item.sta=='OC'"></i>
            <p class="roomType" :class="{'rms':item.abbreviated.length>=6}">
              {{item.abbreviated}}
            </p>
            <p class="roomType" :class="{'rms':item.names.length>6}">
              {{item.names}}
            </p>
            <div class="multChoice" :class="{'choiced':item.choiced}" v-show="isMultSelect">
              <div class="mult-cicle">
                <i class="iconfont icon-right">
                </i>
              </div>
            </div>
          </div>
        </div>
        <nothing :condition="roomList.statusresult != null && roomList.statusresult.length == 0"></nothing>
      </div>
      <div slot="top" class="mint-loadmore-top">
        <span v-show="topStatus !== 'loading'"
              :class="{ 'rotate': topStatus === 'drop' }"> ↓ {{$t('index_refresh')}}</span>
        <span v-show="topStatus === 'loading'">Loading...</span>
      </div>
    </mt-loadmore>
    <div class="fboot"></div>
    <div class="foot_ft" :class='{change:popupFootVisible,l_o_btm:!popupFootVisible}'>
      <mt-popup v-model='popupFootVisible' position="bottom" style="bottom: 2.96rem;" class="footPop" :modal="false">
        <div class="foot_c " style="display:block">
          <div style="width:37.5rem">
            <div class="top" :class='{checked:item.status==searchOption.filterKey}' v-for='item in roomList.filter'
                 :key="item.status" @click='setInfo(item)'>
              <div class="cicle" :style="{background:item.color,borderColor:item.color}">
                <i class="iconfont icon-peopleb2ren " v-if="item.status=='ARR'"></i>
              </div>
              {{item.name}}({{item.num}})
            </div>
          </div>
        </div>
      </mt-popup>
      <div class="foot_d">
        <div class="clearfix flotwarp">
          <div class="bottom" v-for='item in roomList.status' @click='setInfo(item)' :key="item.status">
            <div class="checkbox" :class='{checked:item.status==searchOption.filterKey}'>
              <div class="dimetric" :style="{background:item.color,borderColor:item.color}">
                <i class="iconfont icon-renyuandingwei " v-if="item.status=='OC'||item.status=='OD'"></i>
              </div>
              {{item.name}}({{item.num}})
            </div>
          </div>
        </div>
        <div class="showFBtn" @click='showFoot'>
          <i class="iconfont icon-shanga"></i>
        </div>
      </div>
    </div>
    <actionsheet :actions="actions" v-model="sheetVisible"></actionsheet>
    <mt-popup v-model="popupVisible3" position="right" @touchmove.stop class="mint-popup-3 rightFliterBox"
              :modal="true">
      <div class="rightFliterBox">
        <div class="filter_title">
          <span class="title">{{$t('fliter')}}</span>
          <mt-button @click.native="popupVisible3 = false">
            <i class="iconfont icon-cuowu"></i>
          </mt-button>
        </div>
        <div class="fliter_item" v-for='(itemF,index) in rightList' :key="index"
             v-if='!!serchList[itemF.node]&&serchList[itemF.node].length>1'>
          <div class="category_name">
            <span>{{itemF.name}}</span>
            <p class="showCategory" @click='showmore(index)'
               v-if='!!serchList[itemF.node]&&serchList[itemF.node].length>4'>{{$t('all')}}
              <i class="iconfont icon-xia2 " :class="{open:rightList[index].more=='T'}"></i>
            </p>
          </div>
          <div class="category_list clearfix" :class="{twocol:itemF.node!='building',show:itemF.more=='T'}">
            <div v-for='(item,itemkey) in serchList[itemF.node]' :key="itemkey">
              <div class="option oplist" :class='{checked:item.code==searchOption[itemF.node]}'
                   @click='selectSelf(itemF.node,item)'>{{item.name}}
              </div>
              <!-- <div v-if="itemkey==2&&itemF.more=='F'" class="option" @click='showmore(index)'>...</div> -->
            </div>
          </div>
        </div>
        <div class="fliter_item" v-if="!!serchList['filter']&&serchList['filter'].length>0">
          <div class="category_name">
            <span>{{$t('other')}}</span>
          </div>
          <div class="category_list clearfix twocol">
            <div v-for='(item,itemkey) in serchList["filter"]' :key="itemkey">
              <div class="option oplist" :class='{checked:item.code==searchOption.filterKey}'
                   @click='selectSelf("filterKey",item)'>{{item.name}}
              </div>
            </div>
          </div>
        </div>
        <div class="bottom_f">
          <div class="reset" @click='reset'>{{$t('reset')}}</div>
          <div class="success" @click='sendData'>{{$t('complete')}}</div>
        </div>
      </div>
    </mt-popup>
    <mt-popup v-model="popupVisibleSta" position="bottom" class="checkOutPop" :modal="true">
      <div class="checkList mutlList">
        <label>{{$t('fangT_rmno')}} :</label>{{sheetTemp.rmno}}
      </div>
      <mt-radio :title="$t('fangT_staNew')"
                :max="1" v-model="staNew" :options="stas">
      </mt-radio>
      <div class="popBottom">
        <div class="cCancle" @click='popupVisibleSta=false'>{{$t('cancel')}}</div>
        <div class="cSure" @click="updateSta">{{$t('determine')}}</div>
      </div>
    </mt-popup>
    <mt-popup v-model="popupVisibleStaOS" position="bottom" class="checkOutPop pos" :modal="true">
      <div class="checkList mutlList" style="margin-top:30px">
        <label>{{$t('fangT_rmnos')}}：</label>
        <input type="text" style="height:35px;border:0" v-model="staOOReq.rmnos"
               :placeholder="$t('fangT_rmnos_placeholder')">
      </div>
      <div class="checkList">
        <label>{{$t('fangT_sta')}} :</label>
        <div>{{staOOReq.sta=='O'? $t('maintenance'):$t('lock')}}</div>
      </div>
      <div class="checkList">
        <label>{{$t('fangT_beginDate')}} :</label>
        <div @click="openPick('picker')">{{staOOReq.beginDate | fdate}}</div>
        <mt-datetime-picker ref="picker" type="date" @confirm="handleConfirm" :startDate="minDate"
                            v-model="staOOReq.beginDate"></mt-datetime-picker>
      </div>
      <div class="checkList">
        <label>{{$t('fangT_endDate')}} :</label>
        <div @click="openPick('picker2')">{{staOOReq.endDate | fdate}}</div>
        <mt-datetime-picker ref="picker2" type="date" :startDate="minDate"
                            v-model="staOOReq.endDate"></mt-datetime-picker>
      </div>
      <div class="checkList">
        <label>{{$t('fangT_reasonCode')}} :</label>
        <select class="ooreason" v-model="staOOReq.reasonCode">
          <option value=""></option>
          <option :value="item.code" v-for="item in ooReasonSlot" :key="item.code">{{item.name}}</option>
        </select>
      </div>
      <div class="checkList">
        <label>{{$t('remark')}} :</label>
        <div><input type="text" style="height:35px;border:0" v-model="staOOReq.remark"
                    :placeholder="$t('fangT_remark_placeholder')"></div>
      </div>
      <div class="popBottom">
        <div class="cCancle" @click='popupVisibleStaOS=false'>{{$t('cancel')}}</div>
        <div class="cSure" @click="updateStaO">{{$t('determine')}}</div>
      </div>
    </mt-popup>
  </div>
</template>
<script>
  import _ from "lodash";
  import {Actionsheet, Radio, Toast, MessageBox, Picker} from "mint-ui";
  import nothing from "../operaCommon/nothing";
  import moment from "moment";

  export default {
    data() {
      return {
        mutlSelectTitle: this.$t('fangT_mutlSelectTitle'),
        //   multChoicedArr:[],
        roomList: [],
        serchList: [],
        popupVisible3: false,
        popupFootVisible: false,
        rightList: [
          //楼栋
          {
            name: this.$t("fangT_building"),
            node: "building",
            more: "F"
          },
          //楼层
          {
            name: this.$t("fangT_floor"),
            node: "floor",
            more: "F"
          },
          //房型
          {
            name: this.$t("fangT_rmtype"),
            node: "rmtype",
            more: "F"
          },
          //特征
          {
            name: this.$t("fangT_feature"),
            node: "feature",
            more: "F"
          }
        ],
        searchOption: {
          searchText: "",
          filterKey: "",
          building: "",
          rmtype: "",
          floor: "",
          feature: ""
        },
        stas: [
          {label: this.$t("fangT_RoomStaI"), value: "INSPECTED"},
          {label: this.$t('fangT_RoomStaPU'), value: "PICKUP"},
          {label: this.$t("fangT_RoomStaR"), value: "CLEAN"},
          {label: this.$t("fangT_RoomStaD"), value: "DIRTY"}
        ],
        popupVisibleSta: false,
        staNew: "",
        topStatus: "",
        sheetTemp: {},
        sheetVisible: false,
        actions: [],
        popupVisibleStaOS: false,
        ooReasonSlot: null,
        staOOReq: {
          reasonCode: "",
          sta: "",
          remark: "",
          rmnos: "",
          beginDate: moment(moment().format("YYYY-MM-DD")).toDate(),
          endDate: moment(
            moment()
              .add(1, "d")
              .format("YYYY-MM-DD")
          ).toDate()
        },
        minDate: moment(moment().format("YYYY-MM-DD")).toDate(),
        isMultSelect: false,//是否是多选状态
      };
    },
    mounted() {
      this.getData();
    },
    methods: {

      startRecognize() {
        var options = {engine: "iFly", punctuation: false};
        this.searchOption.searchText = '';
        console.log("开始语音识别");
        var that = this;
        plus.speech.startRecognize(options, function (s) {
          console.log(s);
          that.searchOption.searchText = _.trim(s);
          that.getData();
        }, function (e) {
          that.msg2(this.$t("msg_recognize_fail") + e.message);
        });
      },
      showFliter() {
        if (this.serchList.length == undefined) {
          this.popupVisible3 = true;
          return;
        }
        this.$http
          .post("/mobilepmsapi/opera/biz/getRoomStatusFilter")
          .then(res => {
            if (res.data.result == 0) {
              this.popupVisible3 = true;
              this.serchList = res.data.retVal;
            } else {
              this.msg(res.data.msg);
            }
          });
      },
      showStaOO(sta) {
        this.$http
          .post(
            "/mobilepmsapi/sys/pmsPrarms?type=" +
            (sta == "O" ? "MAINT_REASON" : "LOCK_REASON")
          )
          .then(res => {
            this.staOOReq.sta = sta;
            this.staOOReq.rmnos = this.sheetTemp.rmno;
            this.staOOReq.beginDate = this.minDate;
            this.staOOReq.endDate = moment(moment().add(1, "d").format("YYYY-MM-DD")).toDate();
            this.popupVisibleSta = false;
            if (res.data.result == 0) {
              this.ooReasonSlot = res.data.retVal;
              this.popupVisibleStaOS = true;
            } else {
              this.msg(res.data.msg);
            }
          });
      },
      handleConfirm(d) {
        if (moment(this.staOOReq.endDate) <= moment(this.staOOReq.beginDate)) {
          this.staOOReq.endDate = moment(moment(this.staOOReq.beginDate)
            .add(1, "d")
            .format("YYYY-MM-DD")).toDate();
        }
      },
      updateStaO() {
        this.staOOReq.beginDate = moment(this.staOOReq.beginDate).format("YYYY-MM-DD");
        this.staOOReq.endDate = moment(this.staOOReq.endDate).format("YYYY-MM-DD");
        if (this.staOOReq.reasonCode == "") {
          this.msg2(this.msg_choose_reason);
          return;
        }
        this.popupVisibleStaOS = false;
        this.$http
          .post("/mobilepmsapi/reception/updateRoomStaOSOO", this.staOOReq)
          .then(res => {
            if (res.data.result == 0) {
              this.msg("更新成功");
              this.isMultSelect = false
              this.$refs.topnav.selectMoreing = false
              this.getData();
            } else {
              this.msg(res.data.msg);
              this.popupVisibleStaOS = true;
            }
          });
      },
      openPick(p) {
        this.$refs[p].open();
      },
      updateSta() {
        this.$http
          .post("/mobilepmsapi/opera/biz/updateRoomSta", {
            sta: this.staNew,
            rmno: this.sheetTemp.rmno
          })
          .then(res => {
            this.popupVisibleSta = false;
            if (res.data.result == 0) {
              this.msg("更新成功");
              this.isMultSelect = false
              this.$refs.topnav.selectMoreing = false
              // console.log(this.isMultSelect)
              this.getData();
            } else {
              this.msg(res.data.msg);
            }
          });
      },
      reserveBook() {
        this.sheetTemp.isReserve = true;
        this.$router.push({
          path: "/opera/book?redirect=/opera/fangT",
          query: this.sheetTemp
        });
      },
      walkBook() {
        this.sheetTemp.isReserve = false;
        this.$router.push({
          path: "/opera/book?redirect=/opera/fangT",
          query: this.sheetTemp
        });
      },
      geturl() {
        if (this.$route.query.redirect != null) {
          return this.$route.query.redirect;
        }
        return "/";
      },
      msg(msg) {
        Toast({
          message: msg,
          position: "bottom",
          duration: 3000
        });
      },
      showFoot() {
        this.popupFootVisible = !this.popupFootVisible;
        console.log(this.popupFootVisible);
      },
      getData() {
        this.$http
          .post("/mobilepmsapi/opera/biz/getRoomStatus", this.searchOption)
          .then(res => {
            if (res.data.result == 0) {
              this.roomList = res.data.retVal;
              this.mutlSelectTitle = this.fangT_mutlSelectTitle;
            } else {
              this.msg(res.data.msg);
            }
          });
      },
      pushInRight(vc) {
        this.actions = [];
        if (this.sheetTemp.id > 0) {
          this.actions.push({name: this.fangT_view, method: this.goFangTXQ});
        }
        if (this.roomList.rights.indexOf("rmsta!rmsta") >= 0) {
          if (vc == "D") {
            this.actions.push({name: this.fangT_RoomStaR, method: this.updateRoomStaR});
          } else {
            this.actions.push({name: this.fangT_RoomStaD, method: this.updateRoomStaD});
          }
        }
        if (this.roomList.rights.indexOf("resrv!fit!add") >= 0) {
          this.actions.push({name: this.fangT_reserveBook, method: this.reserveBook});
        }
        this.addWx();
        this.sheetVisible = true;
      },

      pushRight(vc) {
        this.actions = [];
        if (this.sheetTemp.id > 0) {
          this.actions.push({name: this.$t('view'), method: this.goFangTXQ});
        }
        if (this.roomList.rights.indexOf("recept!fit!ci") >= 0) {
          this.actions.push({
            name: this.fangT_walkBook,
            method: this.walkBook
          });
        }
        if (this.roomList.rights.indexOf("resrv!fit!add") >= 0) {
          this.actions.push({name: this.fangT_reserveBook, method: this.reserveBook});
        }
        if (this.roomList.rights.indexOf("rmsta!rmsta") >= 0) {
          if (vc == "IS" || vc == "PU") {
            this.actions.push({name: this.fangT_RoomStaR, method: this.updateRoomStaR});
            this.actions.push({name: this.fangT_RoomStaD, method: this.updateRoomStaD});
          } else if (vc == "VD") {
            this.actions.push({name: this.fangT_RoomStaR, method: this.updateRoomStaR});
          } else if (vc == "VC") {
            this.actions.push({name: this.$t('fangT_RoomStaI'), method: this.updateRoomStaIS});
          } else {
            this.actions.push({name: this.fangT_RoomStaD, method: this.updateRoomStaD});
          }
        }
        this.addWx();
        this.sheetVisible = true;
      },
      addWx() {
      },
      showStaOOO() {
        this.showStaOO("O");
      },
      showStaOOS() {
        this.showStaOO("S");
      },
      pushWxRight(vc) {
        this.actions = [];
        if (this.roomList.rights.indexOf("resrv!fit!add") >= 0) {
          this.actions.push({name: this.fangT_reserveBook, method: this.reserveBook});
        }
        this.sheetVisible = true;
      },
      goRepair() {
        this.$router.push({
          path: "/opera/repair",
          query: {
            rmno: this.sheetTemp.rmno,
            rmtype: this.sheetTemp.rmtype,
            roomSta: this.sheetTemp.pushWxRightroomSta
          }
        });
      },
      goFangTXQ() {
        this.$router.push("/opera/orderDetail?rsvNo=" + this.sheetTemp.id + "&redirect=/opera/fangT");
      },
      unRepair() {
        MessageBox.confirm(this.$t("MessageBox_unRepair"))
          .then(action => {
            this.$http
              .post(
                "/mobilepmsapi/reception/updateRoomStaOSForCancel?rmno=" +
                this.sheetTemp.rmno
              )
              .then(res => {
                if (res.data.result == 0) {
                  this.msg(this.msg_update_success);
                  this.isMultSelect = false
                  this.$refs.topnav.selectMoreing = false
                  this.getData();
                } else {
                  this.msg(res.data.msg);
                }
              });
          })
          .catch();
      },
      updateRoomStaR() {
        this.staNew = "CLEAN";
        this.popupVisibleSta = true;
      },
      updateRoomStaD() {
        this.staNew = "DIRTY";
        this.popupVisibleSta = true;
      },
      updateRoomStaIS() {
        this.staNew = "INSPECTED";
        this.popupVisibleSta = true;
      },
      setInfo(item) {
        if (item.status == this.searchOption.filterKey) {
          this.searchOption.filterKey = "";
        } else {
          this.searchOption.filterKey = item.status;
        }
        this.getData();
      },
      reset() {
        _.map(this.searchOption, (value, key) => {
          this.searchOption[key] = "";
        });
      },
      handleTopChange: function (status) {
        this.topStatus = status;
      },
      loadTop() {
        this.getData();
        this.$refs.loadmore.onTopLoaded();
      },
      sendData() {
        this.popupVisible3 = false;
        this.getData();
      },
      selectSelf(node, item) {
        if (this.searchOption[node] == item.code) {
          this.searchOption[node] = "";
        } else {
          this.searchOption[node] = item.code;
        }
      },
      showmore(item) {
        this.rightList[item].more = this.rightList[item].more == "T" ? "F" : "T";
      },

      touchitem(item) {
        if (this.isMultSelect) {//多选状态下
          // let mutlSelectLength=this.multChoicedArr.length
          this.$set(item, "choiced", !item.choiced)
          let multChoicedArr = []
          _.map(this.roomList.statusresult, (val, key) => {
            if (val.choiced) {
              multChoicedArr.push(val.rmno)
            }
          })
          this.mutlSelectTitle = this.fangT_mutlSelectTitleText + ' ' + multChoicedArr.length + ' ' + this.$t("fangT_mutlSelectTitUnit")
        } else {
          this.goToFangTXQ(item)
        }
      },
      goToFangTXQ(item) {
        this.sheetTemp = {
          rmno: item.rmno,
          rmtype: item.rmtype,
          id: item.id,
          pushWxRightroomSta: item.roomSta
        };
        if (item.arr == "T") {
          this.pushInRight(item.roomSta);
          return;
        } else {
          var path = "fangTXQ"; //根据订单状态 判断按钮
          switch (item.sta) {
            case "VC":
            case "VD":
            case "IS":
            case "PU":
              path = "/opera/book"; //入住中(页面不变，按钮变)
              this.pushRight(item.sta);
              return;
            case "OS":
            case "OO":
              this.pushWxRight(item.sta);
              return;
            //  case "OC":
            //    break;
            default:
              this.pushInRight(item.roomSta);
              return;
          }
          this.$router.push({
            path: path,
            query: this.sheetTemp
          });
        }
      },
      operateMultSelected() {

        let multChoicedArr = []
        _.map(this.roomList.statusresult, (val, key) => {
          if (val.choiced) {
            multChoicedArr.push(val.rmno)
          }
        })
        if (multChoicedArr.length == 0) {
          this.msg(this.msg_choose_room)
          return;
        }
        this.multRoomOperate(multChoicedArr)
      },
      multRoomOperate(multRoomNums) {
        this.sheetTemp = {
          rmno: multRoomNums.join(',')
        }
        this.actions = [];
        if (this.roomList.rights.indexOf("rmsta!rmsta") >= 0) {
          this.actions.push({name: this.fangT_RoomStaR, method: this.updateRoomStaR});
          this.actions.push({name: this.fangT_RoomStaD, method: this.updateRoomStaD});
        }
        this.sheetVisible = true;
      },
      cancleSelectMore() {
        this.isMultSelect = false
        this.mutlSelectTitle = this.fangT_mutlSelectTitle;
        _.map(this.roomList.statusresult, (val, key) => {
          if (val.choiced) {
            val.choiced = false
          }
        })
      },
      goSelect() {
        this.isMultSelect = true
        this.multChoicedArr = []
        //   console.log("进入多选模式")
      },

    },
    computed: {
      msg_choose_reason() {
        return this.$t("msg_choose_reason");
      },
      msg_update_success() {
        return this.$t("msg_update_success");
      },
      msg_choose_room() {
        return this.$t("msg_choose_room");
      },

      fangT_mutlSelectTitle() {
        return this.$t("fangT_mutlSelectTitle");
      },
      fangT_mutlSelectTitleText() {
        return this.$t("fangT_mutlSelectTitleText");
      },
      fangT_mutlSelectTitUnit() {
        return this.$t("fangT_mutlSelectTitUnit");
      },
      fangT_view() {
        return this.$t("fangT_view");
      },
      fangT_RoomStaR() {
        return this.$t("fangT_RoomStaR");
      },
      fangT_RoomStaD() {
        return this.$t("fangT_RoomStaD");
      },
      fangT_reserveBook() {
        return this.$t("fangT_reserveBook");
      },
      fangT_walkBook() {
        return this.$t("fangT_walkBook");
      },
      fangT_RoomStaOOO() {
        return this.$t("fangT_RoomStaOOO");
      },
      fangT_RoomStaOOS() {
        return this.$t("fangT_RoomStaOOS");
      },
      fangT_unRepair() {
        return this.$t("fangT_unRepair");
      },

      hasSelectFilter: function () {
        let flag = false
        let searchOption = this.searchOption || {}
        for (var key in searchOption) {
          if (key != 'searchText' && key != 'villa' && searchOption[key]) {
            flag = true
          }
        }
        return flag
      }
    },
    filters: {
      fdate(value) {
        return moment(value).format("YYYY-MM-DD");
      }
    },
    components: {
      actionsheet: Actionsheet,
      nothing
    }
  };
</script>
<style lang='less' scoped>
  .opera-ft {
    height: 100%;

    .fangt_top {
      height: 1.26666667rem;
      width: 10rem;
      background: #fff;
      padding: 0.18666667rem 0;
      box-sizing: border-box;
      position: absolute;
      top: 1.04rem;
      left: 0;
      z-index: 999;

      .mintui-back {
        font-size: 0.7rem;
        line-height: 0.853333rem;
        color: #c3c3c3;
      }

      .search {
        margin-left: 0.14rem;
        border-radius: 0.44rem;
        width: 6.1rem;
        float: left;
        height: 0.85333333rem;
        background-color: #f7f8fa;
        padding: 0 0.26666667rem;
        overflow: hidden;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        i.icon-sousuo {
          vertical-align: bottom;
          font-size: 0.42666667rem;
          color: #ccc;
          line-height: 0.89333333rem;
        }

        input {
          padding-left: 0.2rem;
          width: 3.28rem;
          vertical-align: middle;
          //margin-bottom: 0.13333rem;
          flex: 1;
          height: 0.62666667rem;
          background-color: #f7f8fa;
          outline: 0;
          border: 0;
        }

        .cleartext {
          float: right;

          i.icon-cuowu {
            line-height: 0.32rem;
            background-color: #c3c3c3;
            border-radius: 50%;
            font-size: 0.32rem;
            text-align: center;
            color: #fff;
            padding: 0.13333333rem;
            margin-top: 0.13333333rem;
            -webkit-transform-origin-x: 0;
            transform: scale(0.6);
            -webkit-transform: scale(0.6);
            width: 0.32rem;
            display: inline-block;
          }

          i.icon-yuyin {
            line-height: 0.85333333rem;
            font-size: 0.5rem;
            color: #999;
            text-align: center;
            padding-right: 0.13333333rem;
            display: inline-block;
          }
        }
      }

      .searct_btn {
        width: 1.73333333rem;
        box-sizing: border-box;
        text-align: left;
        float: left;
        height: 100%;
        font-size: 0.32rem;
        line-height: 0.89333333rem;
        color: #5b5b5b;
        padding-left: 0.33333333rem;
      }

      .line {
        float: left;
        width: 0.02666667rem;
        height: 0.53333333rem;
        background-color: #ccc;
        margin-top: 0.21333333rem;
      }

      .mint-button {
        height: 100%;
        background: #fff;
        box-shadow: none;
        padding: 0;

        .fliter {
          width: 1.86666667rem;
          float: left;
          font-size: 0.32rem;
          line-height: 0.89333333rem;
          text-align: right;
          box-sizing: border-box;
          color: #5b5b5b;

          .iconfont {
            display: inline-block;
            margin-left: 0.13333333rem;
          }
        }
      }
    }

    .all_ft {
      width: 100%;
      margin-top: 2.332rem;

      .fcolor {
        .roomNo,
        .roomType {
          color: #000 !important;
        }
      }

      .roomList {
        width: 2rem;
        height: 2rem;
        position: relative;
        top: 0.02666667rem;
        float: left;

        .item {
          border-bottom: 1px solid #fff;
          box-sizing: border-box;
          height: 100%;
          width: 100%;
          background-color: #00cfcf;
          overflow: hidden;
          -webkit-touch-callout: none;
          -webkit-user-select: none;
          -khtml-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
          position: relative;

          &.rightBorder {
            border-right: 1px solid #fff;
          }

          .icon-peopleb2ren, .icon-renyuandingwei {
            position: absolute;
            color: #444;
            font-size: .32rem;
            top: 2px;
            line-height: 0.5rem;
            right: 0;

          }

          p {
            text-align: center;
            color: #333;
            margin: 0;
          }

          .roomNo {
            font-size: 0.32rem;
            height: 0.6rem;
            line-height: 0.6rem;
          }

          .roomType {
            box-sizing: border-box;
            padding: 0 0.06666667rem;
            font-size: 0.33333333rem;
            line-height: 0.66666667rem;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .rms {
            font-size: 0.25rem
          }

          .multChoice {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background-color: rgba(0, 0, 0, .3);

            .mult-cicle {
              display: none;
              position: absolute;
              border-radius: 50%; // border: 1px #f7f8fa solid;
              box-sizing: border-box; // background: rgba(249, 143, 66, 0.4);
              background: #1470df;
              right: 7px; // left: 0;
              // top: 0;
              bottom: 7px; // margin: ~"calc(50% - 10px)" auto 0;
              width: 20px;
              height: 20px;
              text-align: center;
            }

            &.choiced {
              background-color: rgba(0, 0, 0, 0);

              .mult-cicle {
                display: block;

                .iconfont {
                  text-align: center;
                  line-height: 20px;
                  color: #fff;
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }

    .foot_ft {
      box-shadow: 0 -4px 5px rgba(0, 0, 0, 0.1);
      width: 100%;
      position: absolute;
      bottom: 0;
      padding: 0 0.18666667rem;
      box-sizing: border-box;
      background-color: #fff;

      .footPop {
        width: ~"calc(100% - .9rem)";
        left: ~"calc(50% - .5rem)";
        box-shadow: 0 -4px 5px rgba(0, 0, 0, 0.1);
        opacity: 0;
      }

      .showFBtn {
        transition: all 0.1s ease-in-out;
        position: fixed;
        right: 0;
        bottom: 0;
        height: 1rem;
        z-index: 3000;
        width: 1rem;
        text-align: center;
        background: #ccc;
        line-height: 1rem;
        background: #ffffff;
        box-shadow: -0.02666667rem 0 0.10666667rem 0 rgba(0, 0, 0, 0.18);

        .iconfont {
          color: #9b9b9b;
          font-size: 0.37333333rem;
        }
      }

      @media only screen and (max-device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
        .showFBtn {
          height: 1.8933rem;
          line-height: 1.8933rem;
        }
      }

      .foot_c {
        height: 1rem;
        width: ~"calc(100% - 1rem)";
        width: 100%;
        background-color: #fff;
        border-bottom: 1px solid #ddd;
        padding: 0.16rem 0.26666667rem;
        box-sizing: border-box;
        overflow-y: hidden;
        overflow-x: auto;

        .top {
          margin-top: 0.1rem; // margin-left: 0.36rem;
          // margin-right: 0.15rem;
          float: left;
          text-align: left;
          color: #333; // padding: 0.05333333rem 0;
          padding: 0.1rem 0.1867rem;
          box-sizing: border-box;

          .cicle {
            width: 0.33333333rem;
            height: 0.33333333rem;
            margin-right: 0.08rem;
            margin-top: -0.04rem;
            float: left;
            border-radius: 50%;
            border: 1px solid #969696;
            vertical-align: middle;
            position: relative;

            .iconfont {
              text-align: center;
              line-height: 0.30rem;
              vertical-align: text-top;
              font-size: 0.30rem;
              color: #333;
            }

            .icon-peopleb2ren {
              margin-left: 2px;
            }
          }
        }

        .checked {
          background: #f98f3c;
          border-radius: 0.26666667rem;
          padding: 0.1rem 0.1867rem;
          color: #fff;

          .cicle {
            border: none;
            background: #fff; //   border: 1px solid #969696;
            margin-top: 0px;
          }
        }
      }

      .foot_d {
        /*height: 1rem;*/
        background-color: #fff;
        width: 100%;
        overflow-x: auto;
        overflow-y: hidden;
        height: 1rem;
        transition: all 0.3;
      }

      .flotwarp {
        width: 18rem; //   transition: all 0.1s ease-in-out;
        .bottom {
          margin: 0.21333333rem 0 0 0;
          float: left;
          text-align: left;
          height: 100%;
          color: #333;
          line-height: 1rem;
          line-height: 0.56rem;
          box-sizing: border-box;
          -webkit-tap-highlight-color: transparent;
          -webkit-user-select: none;
          -moz-user-focus: none;
          -moz-user-select: none;
          width: auto;

          .checkbox {
            display: inline-block;
            padding: 0 0.26666667rem;
            text-align: center;

            &.checked {
              background: #f98f3c;
              border-radius: 0.26666667rem;
              color: #fff;
            }

            .dimetric {
              width: 0.33333333rem;
              height: 0.33333333rem;
              margin-right: 0.08rem;
              float: left;
              border-radius: 0.1rem;
              border: 1px solid #969696;
              margin-top: 0.08rem;
              background: #fff;
              position: relative;

              .iconfont {
                color: #333;
                text-align: center;
                line-height: 0.30rem;
                vertical-align: text-top;
                font-size: 0.30rem;
              }

              //   .expArr{
              //     vertical-align: text-top;
              //     position: absolute;
              //     width: 80%;
              //     left: 1px;
              //     right: 0;
              //     margin: 0 auto;
              //     top:1px;
              // }
              // .occupied{
              //      vertical-align: text-top;
              //     position: absolute;
              //     width: 85%;
              //     left: 0 ;
              //     right: 0;
              //     margin: 0 auto;
              //     top:0px;
              // }
            }
          }

          .change {
            width: 33.3%;
          }
        }
      }
    }

    .change {
      .footPop {
        opacity: 1;
      }

      box-shadow: none;

      .showFBtn {
        height: 3.96rem;
        transition: all 0.1s ease-in-out;

        .iconfont {
          line-height: 3.96rem;
          font-size: 0.37333333rem;
          transform: rotate(180deg);
          display: inline-block;
        }
      }

      .foot_d {
        overflow-y: inherit;
        height: 2.96rem;
        width: ~"calc(100% - 1rem)";

        .flotwarp {
          width: 100%;

          .bottom {
            width: 33.3%;
          }
        }
      }
    }

    .mint-popup-3 {
      width: 6.13333333rem;
      height: 100%;

      .rightFliterBox {
        overflow: auto;
        width: 6.13333333rem;
        height: 100%;
        box-shadow: none;
        top: 0;
        background-color: #fff;
        transition: right 0.5s ease-in-out;
        box-shadow: 0 .02666667rem .4rem #0006;

        .filter_title {
          width: 100%;
          height: 1.2rem;

          .title {
            float: left;
            line-height: 1.2rem;
            font-size: 0.4rem;
            margin-left: 0.4rem;
          }

          .mint-button {
            float: right;
            height: 100%;
            background: #fff;
            box-shadow: none;

            .icon-cuowu {
              float: right;
              margin-right: 0.0267rem;
              line-height: 1.2rem;
              font-size: 0.4rem;
            }
          }
        }

        .fliter_item {
          margin-top: 0.4rem;
          padding: 0 0.26666667rem;

          &:nth-last-of-type(2) .category_list {
            border-bottom: 1.33333333rem solid #fff;
            /*padding-bottom: 1.33333333rem;*/
          }

          .category_name {
            height: 0.33333333rem;
            margin: 0 0.26666667rem 0.06666667rem;

            span {
              font-size: 0.26666667rem;
              color: #9B9B9B;
            }

            .showCategory {
              float: right;
              color: #606060;
              font-size: 0.26666667rem;

              .iconfont {
                margin-left: 5px;
                font-size: 0.26666667rem;
                transition: all 0.2s linear;
                display: inline-block;

                &.open {
                  transform: rotate(180deg);
                }
              }
            }
          }

          .category_list {
            padding: 0.26666667rem 0 0.12rem;
            border-bottom: 0.02666667rem solid #efefef;

            .option {
              font-size: 0.33333333rem;
              width: 1.6rem;
              margin: 0px 0.13333333rem 0.26666667rem;
              float: left;
              border-radius: 0.10666667rem;
              background-color: #efefef;
              color: #606060;
              text-align: center;
              line-height: 0.69333333rem;
              overflow: hidden;
              height: 0.69333333rem;
            }

            & .checked {
              background-color: #f98f3c;
              color: #fff;
            }

            &.twocol {
              height: 2.6667rem;
              overflow: hidden;

              &.show {
                height: auto;
              }

              .option {
                width: 2.53333333rem;
                color: #333333;
              }
            }
          }
        }

        .bottom_f {
          position: fixed;
          width: 6.13333333rem;
          bottom: 0;
          height: 1.2rem;
          padding: 0.26666667rem 0;
          box-sizing: border-box;
          color: #fff;
          background-color: -webkit-linear-gradient(to left, #ff5a51, #ffa500);
          background-color: -o-linear-gradient(to left, #ff5a51, #ffa500);
          background-image: linear-gradient(to left, #ff5a51, #ffa500);

          .reset {
            float: left;
            text-align: center;
            font-size: 0.42666667rem;
            line-height: 0.66666667rem;
            height: 0.66666667rem;
            width: 50%;
            box-sizing: border-box;
            border-right: 0.02666667rem solid #fff;
          }

          .success {
            float: left;
            width: 50%;
            line-height: 0.66666667rem;
            height: 0.66666667rem;
            text-align: center;
            font-size: 0.42666667rem;
          }
        }
      }
    }

    .fboot {
      height: 1rem;
      display: block;
    }

    .mint-loadmore {
      position: absolute;
      top: 0px;
      bottom: 40px;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
    }

    .mint-loadmore-top {
      font-size: 0.42rem;
      color: #606060;
    }

    .checkOutPop {
      width: 100%;
      height: 60%;
      margin-top: 40%;
      background: #fff;

      .checkList {
        width: 90%;
        height: 40px;
        padding: 5px 10px;
        text-align: left;
        line-height: 40px;
        margin: 0 auto;
        font-size: 18px;
        border-bottom: 1px dashed #efefef;
        position: relative;
        word-break: break-all;
        font-size: 14px;

        &.mutlList {
          height: auto;
          max-height: 120px;
          overflow-y: auto;
        }

        //       overflow: hidden;
        // text-overflow: ellipsis;
        // white-space: nowrap;
        label {
          height: 40px;
          line-height: 40px;
          width: 60px;
          float: left;
          font-size: 16px;
        }
      }

      .ooreason {
        width: 5rem;
        height: 0.8rem;
        margin-top: 0.08rem;
        border: 1px solid #ccc;

        line-height: 0.64rem;
      }

      .popBottom {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        height: 45px;
        background-image: linear-gradient(-90deg, #ff6e61 0%, #f6a129 98%);

        .cCancle,
        .cSure {
          float: left;
          height: 100%;
          width: 50%;
          color: #fff;
          font-size: 16px;
          box-sizing: border-box;
          border-right: 2px solid #fff;
          text-align: center;
          line-height: 45px;
        }

        .cSrue {
          border-right: none;
        }
      }
    }

    .pos {
      //   z-index:101 !important;
      height: 60%;
      font-size: 14px;

      .checkList {
        font-size: 14px;
        height: 35px;

        label {
          width: 100px;
        }
      }
    }

    .bgnothing {
      text-align: center;
      margin-top: 4.9333rem;
      margin: 4.9333rem 0 0 3.5rem;
    }
  }
</style>



// WEBPACK FOOTER //
// fangT.vue?972d85e8